import { DocumentsFormFieldNames } from 'features/new-actor/enums/documentsFormFieldNames';
import { DocumentVerificationStatusEnum } from 'api/actor';
import { BorrowerContractualizationResponse } from 'api/quote';
import { BorrowerInsuredWithDocumentsFormValues } from './borrowerInsuredWithDocuments.config';

export const selectCniVerificationStatus = (
  values: BorrowerInsuredWithDocumentsFormValues | undefined
): DocumentVerificationStatusEnum | undefined =>
  values?.[DocumentsFormFieldNames.Documents]?.[DocumentsFormFieldNames.Cni]
    ?.verificationStatus as DocumentVerificationStatusEnum | undefined;

export const selectIsCniVerified = (
  values: BorrowerInsuredWithDocumentsFormValues | undefined
): boolean =>
  selectCniVerificationStatus(values) === DocumentVerificationStatusEnum.Verified;

/**
 * Finds the borrower-specific quote tab label inside the contractualization
 * response. Each borrower owns one tab and the label (e.g.
 * "EMP-20260423-235c4cff-MNC-6BM3H") encodes both the product family (EMP)
 * and the partner (MNC).
 */
export const selectQuoteLabelForBorrower = (
  globalInfos: BorrowerContractualizationResponse | null | undefined,
  borrowerId: string | undefined
): string | undefined => {
  if (!globalInfos?.quoteTabs || !borrowerId) return undefined;
  return globalInfos.quoteTabs.find(tab => tab.borrowerId === borrowerId)?.label;
};

/**
 * Detects MNCAP emprunteur quotes based on the quote tab label. A label
 * carrying both the "EMP" product marker and the "MNC" partner marker
 * triggers the broker confirmation gate.
 */
export const isMncapEmprunteurQuoteLabel = (label: string | undefined): boolean => {
  if (!label) return false;
  return label.includes('EMP') && label.includes('MNC');
};
